import * as S from './styles';
import { useCallback } from 'react';
import { Modal } from '@/components';
import VersionHistory from '@/constants/version-history.json';
import { unregisterServiceWorker } from '@/shared/serviceWorkFunctions';

interface ModalVersionHistoryProps {
  isOpenModal: boolean;
  setModalState: (state: boolean) => void;
}

const ModalVersionHistory = ({ isOpenModal, setModalState }: ModalVersionHistoryProps) => {
  const formattedDate = useCallback(() => {
    const date = new Date();
    const day = date.getDate();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const today = `${day}/${month}/${year}`;

    return VersionHistory.date === today ? `Hoje às ${VersionHistory.time}` : `${VersionHistory.date} | ${VersionHistory.time}`;
  }, []);

  const categoryIcon = (category: string): JSX.Element => {
    const CATEGORY_ICON: { [key: string]: JSX.Element } = {
      Novidade: <S.NewFeatureIcon size={12}></S.NewFeatureIcon>,
      Melhoria: <S.ImprovementIcon size={12}></S.ImprovementIcon>,
      Correção: <S.BugIcon size={12}></S.BugIcon>,
    };
    return CATEGORY_ICON[category];
  };

  return (
    <Modal id="version-history" direction="bottom" isOpen={isOpenModal} closeModal={setModalState}>
      <S.VersionModal className="version-modal">
        <S.ModalHeader className="modal-header"></S.ModalHeader>
        {VersionHistory.version === '1.3.1' && (
          <S.ModalTitle> 🟦 Grande Novidade: Hierarquia para Coordenadores </S.ModalTitle>
        )}
        <S.ModalTitle>O que teve de novidades nessa versão?</S.ModalTitle>
        <S.Date>
          <S.ClockIcon size={16} />
          {formattedDate()}
        </S.Date>

        <S.VersionLine className="version-line">
          <S.TransparentBlock className="transparent">
            <S.VersionLabel onClick={() => unregisterServiceWorker({})}>Versão &#8226; {VersionHistory.version}</S.VersionLabel>
          </S.TransparentBlock>
        </S.VersionLine>

        <S.VersionList className="version-list">
          <S.Cards>
            {VersionHistory.changes.map((item, index) => (
              <S.VersionCard className="version-card" key={index}>
                <S.Timeline className="timeline">
                  <S.Circle className="circle"></S.Circle>
                </S.Timeline>
                <S.VersionInfo className="version-info">
                  <S.VersionCategory $category={item.category} className="version-category">
                    {categoryIcon(item.category)}
                    {item.category}
                  </S.VersionCategory>
                  <S.VersionDescription className="version-description">
                    {Array.isArray(item.description) ? (
                      item.description.length > 1 ? (
                        <S.VersionDescriptionList className="version-description-list">
                          {item.description.map((desc, index) => (
                            <S.VersionDescriptionListItem className="version-description-list-item" key={index}>
                              {desc}
                            </S.VersionDescriptionListItem>
                          ))}
                        </S.VersionDescriptionList>
                      ) : (
                        <S.VersionDescription className="version-description">{item.description[0]}</S.VersionDescription>
                      )
                    ) : (
                      <S.VersionDescription className="version-description">{item.description}</S.VersionDescription>
                    )}
                  </S.VersionDescription>
                </S.VersionInfo>
              </S.VersionCard>
            ))}
          </S.Cards>
        </S.VersionList>
      </S.VersionModal>
    </Modal>
  );
};

export default ModalVersionHistory;
